/**
 * The datalayerName is defined on GoogleTagManager server.
 * It must be exactly this variable name.
 */
export const DATA_LAYER_NAME = 'gtmDL'
